import { render, staticRenderFns } from "./PassiveSkill.vue?vue&type=template&id=495bf268&"
import script from "./PassiveSkill.vue?vue&type=script&lang=js&"
export * from "./PassiveSkill.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports